import { FacturaDetalle } from './FacturaDetalle';
import { PedidoDetalle } from './PedidoDetalle';

export class PedidoEntidad {
    idFormaPago:number;
    id:number;
    numeroFactura:string;
    totalSinImpuestos:number;
    totalDescuentos:number;
    totalConImpuestos:number; 
    total:number;
    totalIva:number;
    tipoDoc:string;
    usuario:string;
    establecimiento:string;
    idCliente:number;
    idEmisor:number;
    valorTarjeta:number;
    valorEfectivo:number;
    idFactura:number;
    det:  PedidoDetalle[]= [];
    llevar:string;
    observacion:string;
    enviado:string;
    caja:number;
    costo:number;
    fechaHora:string;
    }
    